import { DashboardSelectorController } from './dashboard-selector.controller';

/**
 * Directive to display a drop down to switch between dashboards.
 */
angular
    .module('cfn')
    .component('dashboardSelector',  {
        templateUrl: require('./dashboard-selector.html'),
        controller: DashboardSelectorController,
        controllerAs: 'ctrl'
    });
